export const PAGE_TITLE = "Payment Setup";

export const ALERTS = {
  LOAD_ACCOUNT_FAILED: "Failed to load payment account status",
  STRIPE_REFRESH_EXPIRED:
    "Your Stripe onboarding session expired or needs to be restarted. Please click 'Continue Stripe Setup' to try again.",
  CREATE_ACCOUNT_FAILED: "Failed to create account",
  ONBOARDING_LINK_FAILED: "Failed to generate onboarding link",
  DASHBOARD_LINK_FAILED: "Failed to open Stripe dashboard",
  ONBOARDING_OPENED_NEW_TAB:
    "Stripe onboarding opened in a new tab. Please complete the setup there, then return here and click Refresh.",
  ONBOARDING_OPENED_FIRST_TIME:
    "Stripe onboarding opened in a new tab. Please complete the setup there, then return here and click Refresh.",
  SETUP_COMPLETE:
    "Stripe account setup is complete! You can now receive payouts.",
  POLLING_VERIFYING:
    "Verifying your Stripe setup... This may take a few moments.",
};

export const STRIPE_CONNECT = {
  CARD_TITLE: "Stripe Connect Account",
  REFRESH_BUTTON: "Refresh",
  NO_ACCOUNT_INTRO:
    "To receive payouts for your sessions, you need to connect a Stripe account. This allows Nirva to securely transfer your earnings directly to your bank account.",
  NO_ACCOUNT_DURATION:
    "Stripe will guide you through the setup process, including identity verification and bank account connection. This typically takes 5-10 minutes.",
  COUNTRY_SELECT_LABEL: "Your Country",
  COUNTRY_SELECT_HELPER:
    "Select the country where you are legally based and will receive payouts. This cannot be changed after account creation.",
  CONNECT_BUTTON: "Connect Stripe Account",
  SETTING_UP: "Setting up...",
  CHIP_VERIFICATION_FAILED: "Verification Failed",
  CHIP_AWAITING_VERIFICATION: "Awaiting Verification",
  CHIP_ONBOARDING_INCOMPLETE: "Onboarding Incomplete",
  CHIP_CONNECTED: "Connected",
  CHIP_CHARGES_ENABLED: "Charges Enabled",
  CHIP_PAYOUTS_ENABLED: "Payouts Enabled",
  VERIFICATION_FAILED_INTRO:
    "Your information was submitted but Stripe could not verify your identity. Please update your information to resolve the issue.",
  VERIFICATION_ISSUES_LABEL: "Verification issues:",
  VERIFICATION_TIP_TEST_MODE:
    "Tip: In Stripe test mode, use the test identity data for your selected country. For US accounts use SSN 000-00-0000. Use name Jenny Rosen for verification to succeed.",
  AWAITING_VERIFICATION_INTRO:
    "Your details have been submitted to Stripe. Verification is in progress and typically completes within a few minutes.",
  INCOMPLETE_INTRO:
    "Your Stripe account has been created but setup is not yet complete. Please finish the onboarding process to start receiving payouts.",
  REMAINING_REQUIREMENTS: "Remaining requirements:",
  BUTTON_LOADING: "Loading...",
  BUTTON_UPDATE_INFO: "Update Information",
  BUTTON_REVIEW_STRIPE: "Review Stripe Setup",
  BUTTON_CONTINUE_STRIPE: "Continue Stripe Setup",
  FULLY_ONBOARDED_INTRO:
    "Your Stripe account is fully set up. You will receive biweekly payouts for completed sessions.",
  OPEN_DASHBOARD: "Open Stripe Dashboard",
};

export const TIER_CARD = {
  TITLE: "Current Tier",
  SESSIONS_AVERAGE: "sessions/week average",
  REVENUE_SPLIT: "Revenue split:",
  REVENUE_SPLIT_YOU: "(you)",
  REVENUE_SPLIT_NIRVA: "(Nirva)",
  TIER_DESCRIPTION:
    "Your tier is based on your selected plan. Contact your administrator to request a change.",
  ACTIVITY_PREFIX: "Your 4-week average: ",
  ACTIVITY_SUFFIX: " sessions/week",
  NEAR_THRESHOLD_PREFIX: "You're averaging ",
  NEAR_THRESHOLD_MID: " sessions/week. Tier ",
  NEAR_THRESHOLD_AT: " starts at ",
  NEAR_THRESHOLD_SUFFIX:
    "/week — talk to your administrator about upgrading.",
};

export const EARNINGS = {
  TITLE: "Earnings Summary",
  TOTAL_EARNINGS: "Total Earnings",
  GROSS_REVENUE: "Gross Revenue",
  TOTAL_SESSIONS_PAID: "Total Sessions Paid",
};

export const PAYOUT_HISTORY = {
  TITLE: "Payout History",
  COLUMN_PERIOD: "Period",
  COLUMN_CLIENT: "Client",
  COLUMN_GROSS: "Gross",
  COLUMN_YOUR_SHARE: "Your Share",
  COLUMN_TIER: "Tier",
  COLUMN_STATUS: "Status",
  PATIENT_NA: "N/A",
};

export const POLLING = {
  INTERVAL_MS: 3000,
  MAX_ATTEMPTS: 6,
};

export const URL_PARAMS = {
  ONBOARDING_COMPLETE: "stripe_onboarding",
  ONBOARDING_COMPLETE_VALUE: "complete",
  STRIPE_REFRESH: "stripe_refresh",
  STRIPE_REFRESH_VALUE: "true",
};

